<template>
  <div :class="['cms-container', _isMobile() ? 'mobile' : '']" style="padding-top:30px;width:90%;margin:20px auto">
     <a-row>
      <a-col :xs="24" :sm="24" :md="12" :lg="8" :xl="8">
       <ul class="cmsUl">
        <li class="cmsList" 
          :class="[cmsDetailsInfo.id == item.id ? 'cmsListActive':'']" 
          v-for="item,index in cmsDataSource" 
          :key="index"
          @click="toDetails(item)">
          {{item.cmsTitile}}
        </li>
       </ul>
      </a-col>
      <a-col :xs="0" :sm="0" :md="12" :lg="16" :xl="16">
        <template v-if="cmsDetailsInfo.cmsType == 1">
          <div class="cmsContent" v-html="cmsDetailsInfo.cmsContent" ></div>
        </template>
        <template v-else-if="cmsDetailsInfo.cmsType == 5">
          <div class="cmsContent" >
            <iframe class="cmsContentIframe"  frameborder="0" style="border: none;" :src="cmsDetailsInfo.extraLink"></iframe>
          </div>
        </template>
        <template v-else-if="cmsDetailsInfo.cmsType == 6">
          <div class="cmsContent" >
                <pdf  
                v-for="i in numPages" 
                :key="i" 
                :page='i' 
                :src="cmsDetailsInfo.extraFile_url"
                @progress="onProgress"
                @error="onError"
                @loaded="onLoaded"  ></pdf>
          </div>
        </template>
      </a-col>
     </a-row>
  </div>
</template>

<script>
import { mixinDevice } from "@/utils/mixin.js";
import { getAction } from "@/api/manage";
import "@/assets/less/animation.css";
import pdf from "vue-pdf";
export default {
  mixins: [mixinDevice],
  components: {pdf},
  data() {
    return {
      cmsDataSource: [],
      cmsDetailsInfo:{},
      loading: false,
      queryParam: {
        pageNo: 1,
        pageSize: 1200,
      },
       numPages: 0,
       pdfLoading:true
    };
  },
  created() {
    console.log(this.$route.query.id , '地址参数')
    if(this.$route.query){

    }
    this.init(this.$route.query.id);
  },
  watch: {

  },
  methods: {
    init(id=null) {
      let _this = this
      this.loading = true;
      this.cmsDataSource = [];
      getAction("/teaching/teachingCms/getCmsList", this.queryParam).then(
        (res) => {
          if (res.success) {
            _this.cmsDataSource = res.result.records;
            if(id){
              _this.cmsDetailsInfo = res.result.records.find(ele => ele.id == id) || res.result.records[0]
            }else{
              _this.cmsDetailsInfo = res.result.records[0]
            }
            _this.$nextTick(()=>{
              if(_this.cmsDetailsInfo.cmsType == 6){
                console.log('我是pdf文件？')
                  _this.cmsDetailsInfo.extraFile_url = _this.convertToHttps(_this.cmsDetailsInfo.extraFile_url )
                  _this.getNumPages()
              }
            })
          }
          this.loading = false;
        }
      );
    },
     getNumPages() {
      console.log('我开始解析pdf文件')
      let loadingTask = pdf.createLoadingTask(this.cmsDetailsInfo.extraFile_url);
      loadingTask.promise.then(pdf => {
        this.numPages = pdf.numPages;
        this.pdfLoading = false
        console.log('我解析成功了pdf文件')
      }).catch(err => {
        console.error('PDF 加载失败', err);
        this.pdfLoading = false
      });
    },
    convertToHttps(url) {
      // 检查 URL 是否以 http:// 开头
      if (url.startsWith('http://')) {
        // 替换为 https://
        return url.replace('http://', 'https://');
      }
      // 如果不是 http://，直接返回原 URL
      return url;
    },
    onProgress(progress) {
      console.log(progress , `PDF 加载进度：${progress.loaded / progress.total * 100}%`);
    },
    onError(error) {
      console.error('PDF 加载失败：', error);
      // this.loading = false; // 加载失败也关闭加载状态
    },
    onLoaded() {
      console.log('加载成功PDF')
      // this.loading = false; // 加载完成
    },
    toDetails(item){
      this.cmsDetailsInfo = item
      this.$nextTick(()=>{
          if(item.cmsType == 6){
            this.cmsDetailsInfo.extraFile_url = this.convertToHttps(this.cmsDetailsInfo.extraFile_url )
            this.getNumPages()
          }
        })
    return
      if (item.cmsType == 5) {
        // 外链
        window.open(item.extraLink);
      } else if (item.cmsType == 2) {
        this.currentItem = item;
        this.videoVisible = true;
        getAction("/teaching/teachingCms/getCmsDetail?id=" + item.id).then(
          (res) => {}
        );
      } else {
        let route = this.$router.resolve({
          path: "/cms/detail",
          query: {
            id: item.id,
          },
        });
        window.open(route.href, "_blank");
      }
    },
  },
};
</script>
<style>
.cmsContent img{
    max-width: 100% !important;
    height: auto !important;
  }
</style>
<style lang="less" scoped>
.cmsUl{
  list-style-type: none;
  position: sticky;
  top: 100px;
  width: 100%;
  height: auto;
  background: #c8e9ff2d;
  padding: 10px;
  border-radius: 10px 0 0 10px;
  .cmsList{
    line-height: 30px;
    font-size: 16px;
    color: #666;
    white-space: nowrap; /* 不换行 */
    overflow: hidden; /* 超出部分隐藏 */
    text-overflow: ellipsis; /* 超出部分显示为省略号 */
    cursor: pointer;
    margin: 0;
  }
  .cmsListActive{
    color: var(--primary-color) !important;
  }
}
.cmsContent{
  padding: 10px;
  // border: 1px solid var(--primary-color);
   background: #c8e9ff2d;
  border-radius:0 10px 10px 0;
  height: calc(100vh - 140px);
  overflow-y: auto;
  .cmsContentIframe{
    width: 100%;
    height: 99%;
  }
}

</style>